// @mui material components

import { forwardRef, useEffect } from "react"
import Modal from "@mui/material/Modal";
import { Divider, Card } from "@mui/material";
import Slide from "@mui/material/Slide";

// @mui icons
import CloseIcon from "@mui/icons-material/Close";

// Material Kit 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";

function BaseModal(props) {
  
  const {show,toggleModal, title, children, lg , ...rest } = props;

  return (
        <Modal {...rest} open={show} onClose={toggleModal}  sx={{ display: "grid", placeItems: "center",maxWidth:{sm:"100%", lg: lg || "576px"}, alignSelf:"center", mx:"auto"}}>
          <Slide direction="down" in={show} timeout={500}>
            <Card
              position="relative"
              width="100%"
              display="flex"
              flexDirection="column"
              borderRadius="xl"
              bgColor="white"
              shadow="xl"
            >
              <MDBox display="flex" sx={{alginItems:"center", justifyContent:"space-between", p:2}}>
                <MDTypography variant="h5">{title}</MDTypography>
                <CloseIcon fontSize="medium" sx={{ cursor: "pointer" }} onClick={toggleModal} />
              </MDBox>
              <Divider sx={{ my: 0 }} />
              <MDBox p={2}>
                {children}
              </MDBox>
              <Divider sx={{ my: 0 }} />
            </Card>
          </Slide>
        </Modal>
  );
}
export const ProductdetailsConainer = forwardRef(({children, show, toggleModal }, ref)=>{
  useEffect(()=>{
    document.querySelector('html').style.overflow = 'hidden';
    return ()=>{
      document.querySelector('html').style.overflow = 'auto';
    }
  },[])
  return (
    <Modal ref={ref} open={show} onClose={toggleModal}  sx={{ display: "grid", placeItems: "center", alignSelf:"center", mx:"auto", overflowY:"scroll"}}>
      {children}
    </Modal>
  )})

export default BaseModal;
